import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { ReopenQueueRequest } from 'domain/usecases';
import { RemoteReopenQueueRequest } from 'data/usecases/queue/remote-reopen-queue-request';

export const makeRemoteReopenQueueRequest = (requestId: string): ReopenQueueRequest => {
  return new RemoteReopenQueueRequest(
    makeApiUrl(`/queue/requests/${requestId}/reopen`),
    makeAuthorizeHttpClientDecorator()
  );
};
